module.exports = __webpack_public_path__ + "img/2valvulas.89ca4287.jpg";